<template>
  <div
    class="ab-test-wrapper"
    :class="cssClass"
  >
    <div class="component-a">
      <slot name="component_a" />
    </div>

    <div class="component-b">
      <slot name="component_b" />
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'AbTestWrapper'
})

defineProps({
  cssClass: {
    type: String,
    default: ''
  }
})
</script>

<style
  lang="scss"
  scoped
>
.ab-test-wrapper {
  .component-a,
  .component-b {
    display: none;
  }

  &.show-a {
    .component-a {
      display: block;
    }
    .component-b {
      display: none;
    }
  }

  &.show-b {
    .component-a {
      display: none;
    }
    .component-b {
      display: block;
    }
  }
}
</style>
